import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeMusicToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeMusicToSpotify}
            sections={<PairTransferGuideContent sourceKey="youtubeMusic" destKey="spotify" />}
        />
    );
}
